<template>

	<div class="flex-grow-1-scroll h-100 position-relative" ref="container"  style="">
		<loading ref="loading"></loading>
        <edit-appointment
            ref='editAppointment'
            v-bind:appointment.sync='selected_appointment' />
		
        <full-image-dialog ref='fullImageDialog' :thread='thread' :in_image='full_image' :show_controls='true' />

        <document-download-dialog ref='documentDownloadDialog' :thread='thread' :in_document_download='document_download' />

		<set-wait :thread='thread' ref='setWait' v-on:validated-wait='setWait()' :validateonly='true'></set-wait>

		<b-modal @ok='setFollowUp' @hidden='resetModalErrors' centered ref="setFollowUpModal" :title="$t('translations.create_follow_up')" size="md">
			<div class='d-block'>

				<b-form-row>
					<b-col cols="10"><label class="col-form-label">{{ $t('translations.send_on_date')}}:</label></b-col>
					<b-col cols="14">
						<div class='no-vdatetime-overlay'>
							
                            <datetime2 v-model="follow_up_at"></datetime2>

							<!-- <input class='form-control' type='date' placeholder='DD/MM/YYYY' date-format="dd/mm/yyyy" v-model="follow_up_at" /> -->
						</div>
					</b-col>
				</b-form-row>

				<inline-error v-bind:errors='errors' type='follow_up_at'></inline-error>

				<div class='pt-3'>
					<label>{{ autobrand('translations.message_to_patient')}}:</label>
					<textarea class="new-message new-message-practice p-1" v-model="follow_up_message" id="follow_up_message_textarea" type="textarea"></textarea>
                    
					<!-- <textarea v-on:keyup.enter.exact="processMessage"  :class='"new-message p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea"  v-text='new_message'></textarea> -->
					<p class='chars-left' aria-live="polite">{{followUpCharactersLeft}}</p>
                    <preset-message-select 
                        targetId='follow_up_message_textarea' 
                        :message='has_record_system_integration() ? "Any codes attached to preset messages WILL NOT be attached to follow-up requests" : ""'
                        @select='follow_up_message = $event.text'>
                        </preset-message-select>
					<inline-error v-bind:errors='errors' type='follow_up_message'></inline-error>
				</div>

				<hr>

				<b-form-row>
					<b-col cols="10"><label class="col-form-label">{{ $t('translations.await_reply_until')}}:</label></b-col>
					<b-col cols="14">
                        <datetime2 v-model="follow_up_wait_until"></datetime2>
					</b-col>

					<!-- <b-col cols="24"><label class="col-form-label">Await reply for
					<b-form-input v-model="follow_up_wait_until"
	                  	style='display: inline-block; width: 4em' type="number" min='1' max='9'></b-form-input> {{wait_time_measure}}</label>
					</b-col> -->

				</b-form-row>
				<inline-error v-bind:errors='errors' type='follow_up_wait_until'></inline-error>

				<hr>

				<b-form-row>
					<b-col cols="10"><label>{{ $t('translations.if_no_reply_move_to')}}:</label></b-col>
					<b-col cols="14">
						<div class="form-check">
							<input v-model='post_follow_up_complete' id='pws_completed' class="form-check-input" type="radio" name="post_wait_complete_f" value="1">
							<label class="form-check-label" for="pws_completed">
							{{ $t('translations.completed')}}
							</label>
						</div>
						<div class="form-check">
							<input v-model='post_follow_up_complete' id='pws_assigned' class="form-check-input" type="radio" name="post_wait_complete_f" value="0">
							<label class="form-check-label" for="pws_assigned">
							{{ $t('translations.current_assignee')}}
							</label>
						</div>
					</b-col>
				</b-form-row>
				<inline-error v-bind:errors='errors' type='post_follow_up_complete'></inline-error>

			</div>
		</b-modal>

		<b-modal v-if='thread && thread.user' centered ref="videoChatModal" :title="$t('translations.start_video_call')" hide-footer size="md">

			<template v-if='this.$root.video_ready'>
			    <h5>{{$t('translations.send_video_request_to')}} <strong>{{formatNameCompliant(thread.user)}}</strong></h5>

				<p v-if="thread && thread.user !== null">
					<span style='white-space: nowrap;'>{{$t('translations.born')}}: <strong>{{thread.user.dob | formatDate}} <template v-if='thread.user.dob'>({{thread.user.dob | getAge}}y)</template></strong></span><br>
					<span style='white-space: nowrap;'>{{$t('translations.gender')}}: <strong>{{getGender(thread.user.gender)}}</strong></span><br>
					<span style='white-space: nowrap;'>{{$t('translations.NHS_number')}}: <strong>{{thread.user.nhs_number}}</strong></span>
				</p>
				<hr>
				<div class="d-flex justify-content-between">
					<button class="btn btn-outline-primary btn-round" v-on:click.prevent='$refs.videoChatModal.hide()'>{{$t('translations.cancel')}}</button>
					<button class="btn btn-primary btn-round" v-on:click.prevent='sendVideoRequest'>{{$t('translations.send_video_request')}}</button>
				</div>
			</template>
			<template v-else>
				<p class='mb-2'>
					{{ $t('translations.waiting_for_video_to_initialise')}}
				</p>
				<button class="btn btn-outline-primary btn-round" style='float:right' v-on:click.prevent='$refs.videoChatModal.hide()'>{{ $t('translations.close')}}</button>
			</template>
		</b-modal>

        <copy-dialog
            ref='copyDialog'
            :thread='thread'
            :messages='items.data'
            :cachedimagedata='image_data'
            :cacheddocumentdata='document_data'
            :allowotherwriteback='allowOtherWriteback'
            v-on="$listeners"></copy-dialog>

        <thread-code-edit
            ref='threadCodeEdit'
            :thread='thread'></thread-code-edit>
            
            

		<div class="d-flex flex-row no-gutters h-100">
            <form-submission v-if='form_submission_id' 
                :form_submission_id='form_submission_id'
                :user='thread.user'
                v-on:close='form_submission_id = null'>
            </form-submission>
            
			<div v-if='form_submission_id == null' ref="content-container" class="col-md-16 d-flex flex-column h-100">

				<header ref="header" class="p-2 header__dashboard--top scroller-header-shadow">

						<patient-banner
                            v-if='thread'
                            :show-close='true'
                            v-on:close='closePanel()'
                            v-bind:user.sync='thread.user' />
						<!-- <button v-on:click="toBottom()">To most recent message</button> -->
						<!-- <button class="btn pos_t1 pos_r1 btn-more-options" role="button" v-bind:class="{ active: showRightPanel }"
								v-on:click="showRightPanel = !showRightPanel">
							<img src="img/icon-more.svg">
							<span class="sr-only">More options</span>
						</button> -->
						<!-- <p v-if='in_thread.length > 1' class="alert alert-danger">Others viewing this request: <ul class='comma-list'><li class='alert-danger' v-for="person in otherStaff">{{formatName(person)}}</li></ul></p> -->


					<!-- <div v-show='items.data instanceof Array && items.data.length === 0'>No items found.</div> -->

				</header>
                <div class="flex-grow-1-scroll message-item" ref="message-list-container">
				<!-- <div class="message-item" ref="message-list-container"> -->
					<div v-if="thread" ref="request-overview-container" class="card card-default m-2">
						<div v-if="thread.id" class="card-header">
							<div v-on:click="copyTextContent(thread_id)" class="copyTextContent" style="display:inline;">{{ autobrand('translations.requestID') | capitalise }} {{this.thread_id}}</div>
						</div>

						<div v-if="have_question_answers">
							<section class="card-body">
								<template v-for="(item, index) in items.data">
									<template v-if="items.data[index].question_id && items.data[index].question.question_group.question_group_type_id == 1">
										<!-- <p :key='item.id'><span class='h5'>{{item.question.short_content}}</span> : {{item.message}}</p> -->
										<!-- <p :key='item.id'>{{item.message}}</p> -->
										<!-- @todo question_content_type_id -->
										<p :key='index' v-if='$t("qa." + items.data[index].question.short_content) != $t("qa.sc_clinician") && $t("qa." + items.data[index].question.short_content) != $t("qa.sc_like_help_from")'>{{ $t("qa." + items.data[index].question.short_content) }}: {{item.message}}</p>
										<!-- <hr> -->
									</template>
								</template>

								<p v-if='wouldLikeHelpFrom()'>{{ $t("qa.sc_like_help_from") }}: {{wouldLikeHelpFrom().message}}</p>
									
                                <!-- ATTACHMENTS FOR THE QA SECTION AT THE TOP -->
                                <div :key='"attachments-" + item.id' v-for="(item) in items.data">
                                    <template v-if="item.question_id && item.question.question_group.question_group_type_id == 1">
                                        <attachment-display v-if='(item.message_image && item.message_image.length)
                                                 || (item.attached_images && item.attached_images.length)
                                                 || (item.message_document && item.message_document.length)
                                                 || (item.attached_documents && item.attached_documents.length)'
                                            :in_images='item.message_image' 
                                            :in_attached_images='item.attached_images'
                                            :in_documents='item.message_document' 
                                            :in_attached_documents='item.attached_documents' 
                                            :allow_delete='!thread.archived' 
                                            :owner='thread' 
                                            :in_image_data='image_data' 
                                            in_api_load_prefix='message' />
                                    </template>
                                </div>
							</section>
						</div>
                        
                        <!-- <div v-if='thread && thread.id' class="form-group m-2">
                            <div>
                                <div v-if='thread && !thread.closed_at' class="pt-1 dropdown d-inline-block">
                                    <button class="btn btn-secondary btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class='mt-1 fa fa-lg fa-tags'> +</i>
                                    </button>
                                    <div class="p-2 dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <autocomplete class='align-self-stretch form-control'
                                                    v-model='tag'
                                                    ref='ac'
                                                    :source="requestTags"
                                                    @clear='tag = null'
                                                    :resultsDisplay='tagResultDisplay'
                                                    :request-headers="authHeaders"
                                                    @selected='setDisplayValue'
                                                    @close='setDisplayValue'
                                                    >
                                            </autocomplete>
                                    </div>
                                </div>
                                <div :key='tag.tag_id' v-for='(tag, index) in thread.thread_tag' class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                                    <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                                    <a v-if='!thread.closed_at' v-on:click.prevent='deleteTag(index)' href="#">&times;</a>
                                </div>
                            </div>        
                        </div> -->
					</div>
                    
                    <div v-if="thread && !thread.id" class="card-body">
                        <p class='alert alert-info'>
                            {{ autobrand("translations.provider_new_request_intro_text") }}
                        </p>
                        <custom-action-selector 
                            
                            v-model="form_submission_id"
                            init_type='staff' 
                            :custom_actions="$root.provider.custom_action"
                            :user_id="user_id"
                            :user="thread ? thread.user : null">
                        </custom-action-selector>
                    </div>

					<ul class="list list-message practice-message">
						<template v-for="(item, index) in items.data">
							<li v-if='(item.question_id == null || item.question.question_group.question_group_type_id != 1) && item.patient_only != 1' :key='item.id'
								:class='"list-message_item " + getMessageClass(item.user.id) + " " + getMessageAuto(index) + (item.internal ? " message-internal" : "")'>

								<h2 class="h6 d-flex flex-wrap justify-content-between"><span>{{formatNameForItem(item)}}</span> <span class="time-stamp">{{formatDateTime(item.created_at)}}</span></h2>
								<!-- <p>{{JSON.stringify(items.data[index],2, null)}} -->
								<div :class='"list-message_item_body " + (item.internal && item.question_id == null ? "list-message-internal" : "")'>
                                    <!-- ATTACHMENTS FOR INDIVIDUAL MESSAGES (NON-QA) -->
                                    <attachment-display v-if='(item.message_image && item.message_image.length)
                                            || (item.message_document && item.message_document.length)'
                                        :in_images='item.message_image' 
                                        :in_documents='item.message_document' 
                                        :allow_delete='!thread.archived' 
                                        :owner='thread' 
                                        :in_image_data='image_data' 
                                        in_api_load_prefix='message' />

									<template v-if='index == edit_index'>
										<!-- <textarea  :class='"new-message new-message-practice p-1" + (item.internal ? " list-message-internal" : "")' v-model="item.message" type="textarea" v-text='item.message'></textarea> -->
										<textarea  :class='"new-message new-message-practice p-1" + (item.internal ? " list-message-internal" : "")' v-model="item.message" type="textarea"></textarea>
										<div class="d-flex flex-wrap">
											<label class="btn btn-sm btn-light"><input type="checkbox" v-model='item.internal' :value="false"> {{ $t('translations.internal_note')}}</label>
											<button v-on:click="cancelEditMessage(index)" class="btn btn-sm btn-light ml-2">{{ $t('translations.cancel')}}</button>
											<button v-on:click="saveMessage(index)" class="btn btn-sm btn-success ml-2">{{ $t('translations.save')}}</button>
											<span class='chars-left ml-auto' aria-live="polite">{{editCharactersLeft}}</span>
										</div>
									</template>
									<template v-else>
										<span v-if='item.question' v-html='$t("qa."+ item.question.content)' class='message-question-content'></span>
										<p :style='item.video ? {paddingBottom: "5px"} : {}' v-html='formatMessageContent(item)'></p>
										<template v-if='item.video'>
											<gruveo v-if='item.video.ended_at == null'  v-on:end-call='item.video.started_at = $event.started_at; item.video.ended_at = $event.ended_at'
                                                :video-room='item.video.room'
                                                :message-id='item.id'
                                                v-bind:patient-ready.sync='item.video.patient_ready'></gruveo>

											<template v-else>
												<p v-text='"Call ended at " + formatDateTime(item.video.ended_at)'></p>
												<p v-text='"Call lasted for " + moment.utc(moment.duration(moment(item.video.ended_at).diff(item.video.started_at)).as("milliseconds")).format("HH:mm:ss")'></p>
											</template>
										</template>
                                        <message-appointment class='mt-4'
                                            v-if='item.appointment'
                                            :show-book='false'
                                            v-bind:appointment.sync='item.appointment'
                                            v-on:edit_appointment='editAppointment(item.appointment)' />
                                        <div class='mt-4 card card--form'
                                            v-if='item.form_submission && item.form_submission.length'>
                                            
                                            <template v-if='item.form_submission[0].submitted_at'>
                                                <div class='mb-1'>Form submitted at {{ item.form_submission[0].submitted_at | formatDateTime }} by {{ formatNameWithProvider(item.form_submission[0].user, item.provider, item.thread, items.data) }} </div>
                                                <template v-if='item.form_submission[0].content && JSON.parse(item.form_submission[0].content) && JSON.parse(item.form_submission[0].content).readable'>
                                                    <ul v-if='$root.user.message_view == 3' class='mb-1'>
                                                        <li :key='item.name' v-for='item in getPlainAnswers(item.form_submission[0], JSON.parse(item.form_submission[0].content))'>
                                                            <template v-if="item.plain_head_extra">
                                                                <strong>{{ item.plain_head_extra }}</strong> <em>{{ item.plain_head_title }}</em>
                                                            </template>
                                                            <template v-else>
                                                                <strong>{{ item.plain_head_title }}</strong>
                                                            </template>
                                                            <span class="pl-4 d-block">
                                                                {{ item.plain_body }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                    <table v-else-if='$root.user.message_view == 1' class='mb-1 table table-xcompact'>
                                                        <tr :key='item.name' v-for='item in getPlainAnswers(item.form_submission[0], JSON.parse(item.form_submission[0].content))'>
                                                            <th style="font-weight: normal">
                                                                <template v-if="item.plain_head_extra">
                                                                    <strong>{{ item.plain_head_extra }}</strong> <em>{{ item.plain_head_title }}</em>
                                                                </template>
                                                                <template v-else>
                                                                    <strong>{{ item.plain_head_title }}</strong>
                                                                </template>
                                                            </th>
                                                            <td style="background-color: white;"">
                                                                {{ item.plain_body }}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <table v-else-if='$root.user.message_view == 2' class='mb-1 table table-xcompact'>
                                                        <template v-for='item in getPlainAnswers(item.form_submission[0], JSON.parse(item.form_submission[0].content))'>
                                                            <tr :key='item.name' >
                                                                <th style="font-weight: normal">
                                                                    <template v-if="item.plain_head_extra">
                                                                        <strong>{{ item.plain_head_extra }}</strong> <em>{{ item.plain_head_title }}</em>
                                                                    </template>
                                                                    <template v-else>
                                                                        <strong>{{ item.plain_head_title }}</strong>
                                                                    </template>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <td style="background-color: white;">
                                                                    {{ item.plain_body }}
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </table>
                                                    <ul v-else class='mb-1'>
                                                        <li :key='item.name' v-for='item in getPlainAnswers(item.form_submission[0], JSON.parse(item.form_submission[0].content))'>
                                                            <!-- {{ item.plain_head }} {{ item.plain_body }} -->
                                                            <template v-if="item.plain_head_extra">
                                                                <strong>{{ item.plain_head_extra }}</strong> <em>{{ item.plain_head_title }}</em> {{ item.plain_body }}
                                                            </template>
                                                            <template v-else>
                                                                <strong>{{ item.plain_head_title }}</strong> {{ item.plain_body }}
                                                            </template>
                                                        </li>
                                                    </ul>
                                                </template>
                                                <attachment-display v-if='(item.form_submission[0].form_submission_image && item.form_submission[0].form_submission_image.length)
                                                        || (item.form_submission[0].form_submission_document && item.form_submission[0].form_submission_document.length)'
                                                    :in_images='item.form_submission[0].form_submission_image' 
                                                    :in_documents='item.form_submission[0].form_submission_document' 
                                                    :allow_delete='!thread.archived' 
                                                    :owner='thread' 
                                                    :in_image_data='image_data' 
                                                    in_api_load_prefix='formsubmission' />
                                            </template>

                                            <button v-on:click='form_submission_id = item.form_submission[0].id' class="btn btn-round btn-primary w-100"><template v-if='item.form_submission[0].submitted_at'>{{ $t('translations.view_form') }}</template><template v-else>{{ $t('translations.fill_in_form') }}</template> {{ getFormTitle(item.form_submission[0]) }}</button>
                                            <!-- <router-link :to="'/form-submission/' + item.form_submission[0].id" tag="button" class="btn btn-round btn-primary w-100 mb-2"><template v-if='item.form_submission[0].submitted_at'>{{ $t('translations.view_form') }}</template><template v-else>{{ $t('translations.fill_in_form') }}</template> {{ getFormTitle(item.form_submission[0]) }}</router-link> -->
                                        </div>
										<template v-if='thread && !thread.archived && !isMessageDeleted(item) && item.user_id == $root.user.id && !item.appointment && item.automated == 0 && item.question_id == null'>
											<button v-if='item.video == null' v-on:click="editMessage(index)" class="btn-edit">{{$t('translations.edit')}}</button>
											<button v-on:click="deleteMessage(index)" class="btn-delete">{{$t('translations.delete')}}</button>
										</template>

									</template>
								</div>

							</li>
						</template>
					</ul>
					<!-- <small v-if="this.thread" class="text-center" style="width: 100%; float: left; font-size: 0.8rem;font-style: italic;color:#666;">{{ $t('translations.read') }} {{ thread.user_thread_read_status.read_at  | formatDateTime }}  </small> -->
				</div>

				<div ref="footer" v-bind:class="{ notAssigned : autoShowAssign || showAssign, 'scroller-footer-shadow' : true}" >
					<template v-if='!isLocked'>
						<assign
						v-on:close='autoAssignSkipped=true; showAssign=false'
						v-on:assigned='addMessages($event)'
						:thread.sync='thread'
						:thread_id='thread_id'
						:staff='staff'
						:messages.sync='items.data'
                        :cachedimagedata='image_data'
                        :cacheddocumentdata='document_data'
						:last_item_created_at.sync='last_item_created_at'
                        
						v-if="this.thread && this.items && this.items.data && (autoShowAssign || showAssign)"></assign>
                        <!-- :banner='wouldLikeHelpFrom() ? "test" : ""' -->
                        
						<template v-else>
							<local-error v-bind:inline='["follow_up_message", "follow_up_at", "follow_up_wait_until", "post_follow_up_complete", "waiting_until"]'></local-error>

							<div class="form-inline d-flex justify-content-between message-tabs">
								<div class="form-check radio-tab mr-auto" v-if="current_question == null && (thread && thread.closed_at == null)">
									<template v-if='emailable'>
										<input type="radio" name="messageTo" id="default-checkbox" v-model='internal_message' :value="false">
										<label class="form-check-label message-patient" for="default-checkbox" name="messageTo">{{ autobrand('translations.message_to_patient') }}</label>
									</template>
									<input name="messageTo" v-model='internal_message' id="internal-checkbox" type="radio" class="form-check-input" :value="true">
									<label class="form-check-label message-internal" for="internal-checkbox" name="messageTo">{{ $t('translations.internal_note') }}</label>
									<!-- <div v-if='emailable'>
										<button v-if='this.$root.video_enabled' class="btn btn-round btn-outline-primary" v-on:click.prevent="showVideo">{{ $t('translations.video_call') }}</button>
									</div> -->
								</div>

								<priority-flags v-if='thread && thread.closed_at == null' :thread.sync='thread' :thread_id='thread_id' class="priority-flags"></priority-flags>
							</div>

							<form ref="message-create-container" class="message-create">
								
								<template v-if='!isLocked'>
									<template v-if='thread == null || (thread && (thread.closed_at == null || current_question != null))'>

										<div v-if="current_question != null" class="message-qa_item">

											<label v-html='formatContent(question_render, true)'></label>
											<p v-if='questions[current_question].allow_attachment'><label class="position-relative btn btn-primary btn-round" for="message-list-file-attach"><span class="icon icon-attachment-inline"></span><span v-text='attached_images.length ? "Attach another photo or document?" : "Attach a photo or document?"'></span></label></p>
											<div class="d-flex flex-wrap">
												<template v-for="(item, key) in question_buttons">
													<button :class='"btn btn-primary btn-round flex-fill m-1" + (new_message == item.value ? " active" : "")' :key="key" v-on:click.prevent="questionClick(key)">{{item.text}}</button>
												</template>
											</div>

										</div>
										<template v-if="show_text_input">
											<div style="padding: 0 10px">
												<!-- <template v-if="(!current_question) || (current_question && questions[current_question].allow_attachment)">
													<div style="position:absolute; right: 50px; top:-47px;z-index: 1000;">
														<input v-on:change='getAttachment' id='message-list-file-attach' class='hidden-file-input' type="file"> -->
														<!-- image/*,.docx,.doc,.odt,.xls,.xlsx,.ods,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet -->
														<!-- <label v-if="!current_question" style='top:0; right:10px' class="p-2 position-absolute" for="message-list-file-attach">
															<span class="icon icon-attachment-inside"></span>
														</label>
													</div>
												</template> -->
                                                <attachment-display v-if='(attached_images && attached_images.length)
                                                        || (attached_documents && attached_documents.length)
                                                        || attached_form'
                                                    :in_attached_images='attached_images'
                                                    :in_attached_documents='attached_documents' 
                                                    :allow_delete_attached='true' 
                                                    :owner='thread' 
                                                    :in_image_data='image_data'
                                                    :show_images='true' 
                                                    :show_image_names='false' 
                                                    :attached_form='attached_form'
                                                    v-on:remove-form='detach_form' 
                                                    in_api_load_prefix='message' />
												
												<div style='position: relative;width: 100%;'>
													<!-- <textarea v-on:keyup='isTyping' :class='"new-message p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea" v-text='new_message'></textarea> -->
													<!-- v-autosize='new_message'-->
													<textarea :class='"new-message new-message-practice p-1" + (internal_message ? " list-message-internal" : "")' v-model="new_message" type="textarea" id="new_message_textarea"></textarea>
												</div>
												<div class="d-flex">
													<p class='chars-left' aria-live="polite">{{charactersLeft}}</p>
													<template v-if="current_question == null && thread_id != null">
														<div v-if="current_question == null" class="ml-auto">
															<button v-on:click.prevent='showAssign=true' class="link btn-sm bg-light mb-1">
																<template v-if='thread && thread.thread_provider && (thread.thread_provider.assigned_user_id || thread.thread_provider.assigned_group_id)' >{{ $t('translations.assigned_to') }} {{assignee_name}}
																</template>
																<template v-else>{{ capitalise($t('translations.unassigned')) }}
																</template>
															</button>
														</div>
													</template>
												</div>
											</div>
										</template>

										<div class="d-flex flex-row flex-wrap align-items-center message-actions">
											
												<div class='mr-auto' v-if="this.thread_id == null">
													<button class="mb-1 mt-2 btn btn-round btn-warning btn-sm" v-on:click.prevent="closePanel(true, false)">{{$t('translations.cancel')}}</button>
													<button class="mb-1 mt-2 btn btn-round btn-warning btn-sm" v-if='items.data && items.data.length && current_question' v-on:click.prevent="goToPreviousQuestion()">{{$t('translations.back')}}</button>
												</div>

												<div class="ml-auto d-flex">

													<appointment-booking-select :thread_id.sync='thread_id' :user='thread.user' v-if='appointmentsEnabled() && show_text_input && !current_question && thread && (this.thread.user.deleted_at == null)' v-on:inviteSent='inviteSent'>
													</appointment-booking-select>

													<span v-if='thread && thread.id && thread.closed_at == null && has_record_system_integration()' class="icon--message-create icon--message-create__code" v-b-tooltip v-on:click.prevent='$refs.threadCodeEdit.show' :title="$t('translations.edit_codes')"></span>

													<div v-if='emailable && current_question == null && (thread && thread.closed_at == null)'>
														<span v-if='this.$root.video_enabled' class="icon--message-create icon--message-create__video" v-on:click.prevent="showVideo" v-b-tooltip :title="$t('translations.video_call')"></span>
													</div>

													<span v-if='thread && thread.id && thread.thread_provider.waiting_until != null' class="icon--message-create icon--message-create__copy" v-on:click.prevent='allowOtherWriteback = false; $refs.copyDialog.show()' :title="$t('translations.copy')"></span>

													<form-select 
														v-if='show_text_input && !current_question'
														targetId='new_message_textarea' 
														@select='attach_form($event)'>
													</form-select>

													<preset-message-select 
														v-if='show_text_input && !current_question'
														targetId='new_message_textarea' 
														@select='new_message = $event.text; preset_message_id = $event.id'>
													</preset-message-select>

                                                    

													<template v-if="(!current_question) || (current_question && questions[current_question].allow_attachment)">
														<div>
															<input v-on:change='getAttachment' id='message-list-file-attach' class='hidden-file-input' type="file">
															<!-- image/*,.docx,.doc,.odt,.xls,.xlsx,.ods,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet -->
															<label v-if="!current_question" for="message-list-file-attach" class="d-flex">
																<span class="icon--message-create icon--message-create__attachment" v-b-tooltip :title="$t('translations.attach_document')"></span>
															</label>
														</div>
													</template>
													
													<!-- Moving this above <template v-if="current_question == null && thread_id != null">
														<div v-if="current_question == null">

															<button v-on:click.prevent='showAssign=true' class="link">
																<template v-if='thread && thread.thread_provider && (thread.thread_provider.assigned_user_id || thread.thread_provider.assigned_group_id)' >{{ $t('translations.assigned_to') }} {{assignee_name}}
																</template>
																<template v-else>{{ capitalise($t('translations.unassigned')) }}
																</template>
															</button>
													-->
															<!-- <label class="mr-1 small">{{ $t('translations.assign_to') }}:</label>
															<select v-model='assignee' class="form-control custom-select form-control-sm">
																<option value="">{{ $t('translations.unassigned') }}</option>
																<option :key='"u"+index' v-for='(user, index) in staff' v-if='isMemberOfAssignableGroup(user)' :value='"u" + user.id'>
																	{{ formatNameCompliant(user) }}
																	{{ thread && thread.user && user.id == thread.user.provider.preferred_clinician_id ? " | " + $t('translations.usual_GP') : "" }}
																	{{ thread && user.id == thread.requested_clinician_id ? " | " + $t('translations.requested_GP') : "" }}
																	{{ !staff[index].available ? " | " + capitalise($t('translations.away')) : "" }}
																</option>
																<option :key='"g"+index' v-for='(group, index) in $root.lookup.user_groups' v-if='group.group_assignable' :value='"g" + group.id'>{{ $t('translations.group') }}: {{group.name}}</option>
															</select> -->

															<!-- <div data-nickelled-launcher="pulse" data-guide=":guideURL"></div> -->
														<!-- </div>
													</template>  -->

													<span class="icon--message-create icon--message-create__await" v-if='thread && thread.id && thread.thread_provider.waiting_until == null && thread.closed_at == null && !current_question && (this.thread.user.deleted_at == null)' v-on:click.prevent="showWait" v-b-tooltip :title="$t('translations.await_reply')"></span>

													<button v-if='thread && thread.id && thread.thread_provider.waiting_until != null && thread.closed_at == null && question_buttons.length == 0' class="icon--message-create icon--message-create__end-wait" v-on:click.prevent="endWait" v-b-tooltip :title="$t('translations.end_wait') "></button>
													<!-- Original Complete Button -->
													<!-- <button v-if='thread && thread.id && thread.closed_at == null && thread.thread_provider.waiting_until == null && !current_question' class="mb-1 btn btn-outline-primary btn-round mr-1 align-self-end btn-sm" v-on:click.prevent="closeThreadSendAssign">{{ $t('translations.complete') }}</button> -->
													<b-dropdown dropup v-if='thread && thread.id && thread.closed_at == null && !current_question && thread.owner_provider_id == $root.user.provider.id' class="icon--message-create icon--message-create__complete" v-b-tooltip.hover="$t('translations.complete')">
														<div class="p-3">
															<b-dropdown-text>{{ autobrand('translations.how_was_this_request_resolved?')}}</b-dropdown-text>
															<b-dropdown-divider></b-dropdown-divider>
															<b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_message'))">{{$t('qa.option_message')}}</b-dropdown-item>
															<!-- <b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_telephone'))">{{$t('qa.option_telephone')}}</b-dropdown-item> -->
                                                            <b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa(autobrand('qa.option_val_called_patient'))">{{autobrand('qa.option_called_patient')}}</b-dropdown-item>
                                                            <b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_telephone_appt_booked'))">{{$t('qa.option_telephone_appt_booked')}}</b-dropdown-item>
															<b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_face_to_face'))">{{$t('qa.option_face_to_face')}}</b-dropdown-item>
															<b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_video'))">{{$t('qa.option_video')}}</b-dropdown-item>
															<b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_visit'))">{{$t('qa.option_visit')}}</b-dropdown-item>
															<b-dropdown-item v-on:click.prevent="closeThreadSendAssignPostQa($t('qa.option_val_abandoned'))">{{$t('qa.option_abandoned')}}</b-dropdown-item>
														</div>
													</b-dropdown>
													
													<span class="icon--message-create icon--message-create__send ml-1" v-if='thread && thread.closed_at == null && question_buttons.length == 0' v-on:click.prevent="processSendAssign" v-b-tooltip :title="getSendButtonText()">
														
														<!-- <span v-text='getSendButtonText()'></span> -->
													</span>
													<!-- <input v-on:change='getAttachment' v-if="show_text_input" id='message-list-file-attach' class='hidden-file-input' type="file" accept="image/*">
													<label class="position-relative mb-1 ml-1 btn btn-primary btn-round align-self-end btn-sm" for="message-list-file-attach"><span class="icon icon-attachment-inline"></span>Attach</label> -->
												
											</div>
										</div>
									</template>
									<template v-if='thread && thread.closed_at != null'>
										<div class="d-flex message-actions justify-content-end">
											
												<template v-if='this.thread_id !== null'>
                                                    <template v-if='thread.owner_provider_id == $root.user.provider.id'>
                                                        <b-dropdown dropup v-if='!thread.archived' class="icon--message-create icon--message-create__update-completion" v-b-tooltip.hover="capitalise($t('translations.update_completion_method'))">
                                                            <div class="p-3">
                                                                <b-dropdown-text>{{ autobrand('translations.update_completion_method') | capitalise }}</b-dropdown-text>
                                                                <b-dropdown-text>{{ autobrand('translations.how_was_this_request_resolved?')}}</b-dropdown-text>
                                                                <b-dropdown-divider></b-dropdown-divider>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_message'))">{{$t('qa.option_message')}}</b-dropdown-item>
                                                                <!-- <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_telephone'))">{{$t('qa.option_telephone')}}</b-dropdown-item> -->
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion(autobrand('qa.option_val_called_patient'))">{{autobrand('qa.option_called_patient')}}</b-dropdown-item>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_telephone_appt_booked'))">{{$t('qa.option_telephone_appt_booked')}}</b-dropdown-item>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_face_to_face'))">{{$t('qa.option_face_to_face')}}</b-dropdown-item>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_video'))">{{$t('qa.option_video')}}</b-dropdown-item>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_visit'))">{{$t('qa.option_visit')}}</b-dropdown-item>
                                                                <b-dropdown-item v-on:click.prevent="updateCompletion($t('qa.option_val_abandoned'))">{{$t('qa.option_abandoned')}}</b-dropdown-item>
                                                            </div>
                                                        </b-dropdown>
                                                        <template v-if='!thread.archived && emailable'>
                                                            <button v-if='this.thread && this.thread.follow_up_at == null ' class="icon--message-create icon--message-create__followup" v-on:click.prevent="showFollowUp" :title="$t('translations.set_follow_up')" v-b-tooltip></button>
                                                            <button v-else class="icon--message-create icon--message-create__cancel-followup" v-on:click.prevent="cancelFollowUp" :title="$t('translations.cancel_follow_up')" v-b-tooltip></button>
                                                        </template>
                                                        <button v-if='!thread.archived' class="icon--message-create icon--message-create__reopen" :title="$t('translations.re-open')" v-b-tooltip v-on:click.prevent="reopenThread"></button>
                                                    </template>
													<span class="icon--message-create icon--message-create__copy" v-b-tooltip :title="$t('translations.copy')" v-on:click.prevent='allowOtherWriteback = false; $refs.copyDialog.show()'></span>

                                                    <button v-if='!thread.archived && !this.$root.provider.demo_mode && (is_admin() || is_superuser()) && this.thread.owner_provider_id == this.$root.user.provider.id' class="icon--message-create icon--message-create__delete" v-on:click.prevent="deleteThread" v-b-tooltip :title="$t('translations.delete')"></button>
												</template>
											
											<button v-if='current_question != null && question_buttons.length == 0' class="mb-1 btn btn-primary btn-round align-self-end" v-on:click.prevent="processSendAssign"><span class="icon icon-send"></span>{{$t('translations.send')}}</button>
										</div>
									</template>
								</template>
							</form>
						</template>
					</template>
					<template v-else>
						<p v-if='thread && items && items.data' class="alert alert-danger">{{ autobrand('translations.request_locked_by') | capitalise }}: {{formatName(otherStaff[0], isMultiProviderThread(thread, items.data) ? otherStaff[0].provider_name : null)}}. <button v-on:click.prevent='unlockThread()' class='btn btn-round btn-danger btn-sm'>{{$t('translations.button_override_lock')}}</button></p>
					</template>
				</div>
			</div>

			<div class="col-md-8 border-left-separator">
				<div class="right-side_panel open d-flex flex-column h-100" style="">
                    
					<header class="p-2 bg-light scroller-header-shadow">
						<h2 class='h4 mb-0'>{{ autobrand('translations.client_details') }} <span v-if='this.thread && this.thread.user_id' v-b-tooltip :title="autobrand('translations.patientID')" class="float-right h5 mb-0"><span  class="copyTextContent" v-on:click="copyTextContent(thread.user_id)">{{this.thread.user_id}}</span></span></h2>
					</header>

					<div class="m-2" v-if="thread !== null">

						<template v-if='thread.created_by != thread.user_id'>
							<p class='alert alert-info mb-2 p-2'><strong v-text='thread.created_by_user.user_type_id == 2 ? this.autobrand("translations.thread_created_by_staff") : autobrand("translations.thread_created_by_proxy")'></strong></p>
							<div class='container'>
                                <div class="row" v-if='thread.created_by_user.user_type_id == 2'>
                                    <p class='col-10 p-0'>{{$t('translations.staff_name')}}:</p>
                                    <p class="col-14 p-0 text-break">{{formatNameCompliant(thread.created_by_user)}}</p>
                                </div>
                                <div class="row" v-if='thread.created_by_user.user_type_id != 2'>
                                    <p class='col-10 p-0'>{{$t('translations.name')}}:</p>
                                    <p class="col-14 p-0 text-break">{{formatNameCompliant(thread.created_by_user)}}</p>
                                </div>
                                <div class="row" v-if='thread.created_by_user.user_type_id != 2'>
                                    <p class='col-10 p-0'>{{$t('translations.email')}}:</p>
                                    <p class="col-14 p-0 text-break"><a :href='"mailto:" + thread.created_by_user.email'>{{thread.created_by_user.email}}</a></p>
                                </div>
                                <div class="row" v-if='thread.created_by_user.user_type_id != 2'>
                                    <p class='col-10 p-0'>{{$t('translations.phone')}}:</p>
                                    <p class="col-14 p-0 text-break"><a :href='"tel:" + thread.created_by_user.phone_number'>{{thread.created_by_user.phone_number}}</a></p>
                                </div>
                                <div class="row">
                                    <p class='col-10 p-0'>{{ autobrand('translations.patient_name')}}:</p>
                                    <p class="col-14 p-0 text-break">{{formatNameCompliant(thread.user)}}</p>
                                </div>
                                <div class="row" v-if='thread.user.provider.preferred_clinician_id'>
                                    <p class='col-10 p-0'>{{$t('translations.usual_GP')}}:</p>
                                    <p class="col-14 p-0 text-break" v-text='formatNameCompliant(thread.user.provider.preferred_clinician)'></p>
                                </div>
                                <div class="row" v-if='thread.user.phone_number'>
                                    <p class='col-10 p-0'>{{autobrand('translations.patient_phone')}}:</p>
                                    <p class="col-14 p-0 text-break"><a target="call_window" :href='"tel:" + thread.user.phone_number'>{{thread.user.phone_number}}</a></p>
                                </div>
                                <div class="row" v-if='thread.user.phone_number_alt'>
                                    <p class='col-10 p-0'>{{$t('translations.alternative_phone')}}:</p>
                                    <p class="col-14 p-0 text-break"><a target="call_window" :href='"tel:" + thread.user.phone_number_alt'>{{thread.user.phone_number_alt}}</a></p>
                                </div>
                            </div>
						</template>
						<template v-else>
                            <div class='container'>
                                <div class="row" v-if='thread.user.email'>
                                    <p class='col-10 p-0'>{{$t('translations.email')}}:</p>
                                    <p class="col-14 p-0 text-break"><a :href='"mailto:" + thread.user.email'>{{thread.user.email}}</a></p>
                                </div>

                                <div class="row" v-if='thread.user.provider.preferred_clinician_id'>
                                    <p class='col-10 p-0'>{{$t('translations.usual_GP')}}:</p>
                                    <p class="col-14 p-0 text-break" v-text='formatNameCompliant(thread.user.provider.preferred_clinician)'></p>
                                </div>
                                <div class="row" v-if='thread.user.phone_number'>
                                    <p class='col-10 p-0'>{{autobrand('translations.patient_phone')}}:</p>
                                    <p class="col-14 p-0 text-break"><a target="call_window" :href='"tel:" + thread.user.phone_number'>{{thread.user.phone_number}}</a></p>
                                </div>
                                <div class="row" v-if='thread.user.phone_number_alt'>
                                    <p class='col-10 p-0'>{{$t('translations.alternative_phone')}}:</p>
                                    <p class="col-14 p-0 text-break"><a target="call_window" :href='"tel:" + thread.user.phone_number_alt'>{{thread.user.phone_number_alt}}</a></p>
                                </div>
                            </div>
						</template>
                        <button v-if='!this.thread.originating_provider_id && (this.thread && this.thread.user.deleted_at == null) || thread.originating_provider_id == $root.user.provider.id && (this.thread && this.thread.user.deleted_at == null)' class="btn btn-primary btn-sm w-100 mt-2" v-on:click.prevent="openEdit">{{autobrand('translations.edit_patient')}}</button>
						<hr class='mb-2 mt-2'>
                        <div class='container'>
                            <div class="row" v-if='thread'>
                                <p class='col-10 p-0'>{{$t('translations.assigned_to')}}:</p>
                                <p class="col-14 p-0 text-break">{{assignee_name}}</p>
                            </div>
                            <div class="row" v-if='thread && items && items.data && isMultiProviderThread(thread, items.data)'>
                                <p class='col-10 p-0'>{{$t('translations.thread_originated_at')}}:</p>
                                <p v-if='thread.originating_provider && typeof thread.originating_provider == "object"' class="col-14 p-0 text-break">{{ thread.originating_provider.name }} <template v-if='thread.originating_provider.deleted_at'> [DELETED]</template></p>
                                <!-- <p class="col-14 p-0 text-break">{{ thread.originating_provider.name}} </p> -->
                            </div>

                            <div class="row" v-if='thread && items && items.data && isMultiProviderThread(thread)'>
                                <p class='col-10 p-0'>{{$t('translations.shared_with')}}:</p>
                                <p class="col-14 p-0 text-break">
                                    <template  v-for='thread_provider_xref in thread.thread_provider_xref.filter(obj => {return thread.originating_provider_id != obj.provider_id})'>
                                        <div :key='thread_provider_xref.provider_id'>{{ thread_provider_xref.provider.name }} </div>
                                    </template>
                                </p>
                                
                            </div>

                            <div class="row" v-if='(thread.user && typeof thread.user.verification_status_id != "undefined")'>
                                <p class='align-middle col-10 p-0 m-auto'>{{ $t('translations.IDStatus')}}:</p>
                                <p v-bind:class="$root.lookup.verification_statuses[thread.user.verification_status_id] + ' col-14' + (thread.user.verification_status_id == 3 ? ' p-0' : ' p-2')">
                                    <select v-if='thread && thread.user && thread.user.provider.id == $root.provider.id' v-model='thread.user.verification_status_id' class='form-control custom-select' v-on:change="setVerificationStatus">
										<option v-for="(value, key) in $root.lookup.verification_statuses" :value="key" :key="key">{{$t('translations.' + value)}}</option>
									</select>
                                    <template v-else>{{ $root.lookup.verification_statuses[thread.user.verification_status_id]}}</template>
                                </p>
                            </div>
                            <div class="row" v-if='thread && thread.user && thread.user.provider'>
                                <p class='col-10 p-0'>{{$t('translations.preferred_site')}}:</p>
                                <p class="col-14 p-0 text-break">{{getSiteNameById(thread.user.provider.site_id, $root.provider.site, "N/A")}}</p>
                            </div>
                            
                            

                        </div>
					</div>
                    <header class="p-1 pl-2 pr-2 border-top bg-light scroller-header-shadow d-flex justify-content-between align-items-center" style='z-index: 3'>
						<h2 class='h4 mb-0'>{{$t('translations.tags') | capitalise }} </h2>
                        <div v-if='thread && !thread.closed_at' class="ml-auto dropdown d-inline-block">
                            <button :disabled='!thread.id' class="btn btn-secondary btn-round btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class='fa fa-sm fa-tags'> +</i>
                            </button>
                            <div class="p-2 dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <autocomplete class='align-self-stretch form-control'
                                            v-model='tag'
                                            ref='ac'
                                            :source="requestTags"
                                            @clear='tag = null'
                                            :resultsDisplay='tagResultDisplay'
                                            :request-headers="authHeaders"
                                            @selected='setDisplayValue'
                                            @close='setDisplayValue'
                                            >
                                    </autocomplete>
                            </div>
                        </div>
					</header>
                    <div v-if='thread' class="form-group m-2">
                        <div>
                            <template v-for='(tag, index) in thread.thread_tag'>
                                <div v-if='getTag(tag.tag_id).name' :key='tag.tag_id' class='search-lozenge-thin badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                                    <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                                    <a v-if='!thread.closed_at' v-on:click.prevent='deleteTag(index)' href="#">&times;</a>
                                </div>
                            </template>
                        </div>        
                    </div>
					<header class="p-2 border-top bg-light scroller-header-shadow">
						<h2 class='h4 mb-0'>{{autobrand('translations.previous_requests')}}</h2>
					</header>
                    <div class='flex-grow-1-scroll h-100' v-on:click.prevent='showRelatedThreadList = true'>
                        <div class='text-center m-2' v-if='!showRelatedThreadList'>
                            <button class='btn btn-primary btn-sm w-100' >
                                {{autobrand('translations.load_previous_requests')}}
                            </button>
                        </div>
                        <related-thread-list
                            v-if='thread != null && showRelatedThreadList'
                            modalid="related-thread-filter-modal"
                            displayelement = "thread-list"
                            event = "thread"
                            model =  "thread"
                            title = "Requests"
                            path = 'threads'
                            route = '/api/v1/threads'
                            :user = 'thread.user'
                            :exclude_thread_id = 'thread.id'>
                        </related-thread-list>
                    </div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {  
		extends: app.base.messageListBase,
		props: [
			'apiRoute',
			'event',
			'model',
			'path',
			'title',
			'type'
		],

		data: function(){
			return {
				in_thread: [],
				errors: [],
				
				filterFields: {},
				page: 1,
				thread_id: null,
				thread: null,
				user_id: null,
				auxiliary_data: null,
				read_timer: null,
				last_item_created_at: null,
				questions: {},
				current_question: null,
				question_render: "",
				show_text_input: true,
				question_buttons: [],
				internal_message: this.defaultInternal,
				verification_status: {},
				copy_content: "",
				available: false,
				staff: this.$root.lookup.staff,
				events: [],
				confirm_patient_messages: false,
				edit_index: -1,
				pre_edit_content: "",
				waiting_until: 7,
				wait_time_measure: this.environment_settings.MIX_WAIT_TIME_MEASURE,
                post_wait_complete: "1",
                wait_send_message_to_patient: 0,
				follow_up_at: null,
				follow_up_wait_until: 7,
				post_follow_up_complete: 1,
				follow_up_message: "",
                autoAssignSkipped: false,
                showAssign: false,
                apiBase: '/api/v1',
                showRelatedThreadList: false,
                originalData: {
                    "new_message": {name: "Message", value: ""}
                },
                selected_appointment: null,
                tag: null,
                scrollOnUpdate: true,
                allowOtherWriteback: false,
                suppress_close_panel: false,
			};
		},
		computed: {
            defaultInternal() {
                if(!this.emailable) {
                    return true;
                }
                if(this.$root.user) {
                    // Usual messy boolean laravel/vue issue
                    return this.$root.user.default_internal_message ? true : false;
                }
                return true;
            },
			isLocked() {
				if(this.otherStaff.length == 0 || (this.otherStaff.length && this.otherStaff[0].id == this.$root.user.id)) {
					return false;
				}
				return true;
			},
			autoShowAssign() {
				if(this.autoAssignSkipped === true) {
					return false;
				}
				if(this.thread && this.items && this.items.data) {
					//console.log("!!!!!" + this.items.data.filter((obj) => {return (obj.question_id == null & obj.patient_only != 1) }).length);
				}
				if(this.thread
						&& this.items
						&& this.items.data
                        && this.thread
                        && this.thread.thread_provider
						&& !this.thread.question_group_id) {

					// if(this.items.data.length === 0 || this.items.data.filter((obj) => {return (obj.question_id == null && obj.patient_only != 1) }).length) {
					if(this.items.data.length === 0) {
						return false
					}
					if(this.thread.thread_provider.assigned_user_id) {
						return false
                    }
					if(this.thread.thread_provider.assigned_group_id) {
						return false;
                    }
                    if(this.thread.closed_at) {
						return false;
					}

					return true;
				}
				return false;
			},
			emailable() {
				if(this.thread && ((this.thread.created_by && this.$root.is_patient(this.thread.created_by_user) && this.thread.created_by_user.email && this.thread.created_by_user.last_login && (this.thread.user.deleted_at == null)) || (this.thread.user && this.thread.user.email && this.thread.user.last_login) && (this.thread.user.deleted_at == null))) {
					return true;
				}
				return false;
			},
			otherStaff() {
				var others = [];

				others = this.in_thread.sort((a, b) => {
					return ((a.joined_at == b.joined_at) ? 0 : ((a.joined_at > b.joined_at) ? 1 : -1));
				});
				// others = others.filter((obj => {
				//  return obj.id != this.$root.user.id;
				//
                // }));
                //console.warn(others);
				return others;
			},
			charactersLeft() {
				var char = this.new_message.length;
				var limit = 2048;

				if(this.current_question) {

					if(this.questions[this.current_question].limit) {
						limit = this.questions[this.current_question].limit
					}
					else {
						return "";
					}
				}

				if(char > limit) {
					this.new_message = this.new_message.substr(0, limit);
					char = this.new_message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},
			followUpCharactersLeft() {
				var char = this.follow_up_message.length;
				var limit = 2048;

				if(char > limit) {
					this.follow_up_message = this.follow_up_message.substr(0, limit);
					char = this.follow_up_message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},

			editCharactersLeft() {
				var item = this.items.data[this.edit_index];
				if(!item) {
					return "";
				}
				var char = item.message.length;
				var limit = 2048;

				if(item.question_id) {
					if(this.questions["q-" + item.question_id].limit) {
						limit = this.questions["q-" + item.question_id].limit;
					}
					else {
						return "";
					}
				}

				if(char > limit) {
					item.message = item.message.substr(0, limit);
					char = item.message.length;
				}
				return (limit - char) + " " + this.$t('translations.characters_remaining');
			},

			connected() {
				return this.$root.connected;
			},
			assignee_name() {
				// @todo Convert these to use find instead.
				if(this.thread && this.thread.thread_provider) {
					if(this.thread.thread_provider.assigned_user) {
						return this.formatName(this.thread.thread_provider.assigned_user);
					}
					else if(this.thread.thread_provider.assigned_group) {
						return this.$t('translations.group') + ": " + this.thread.thread_provider.assigned_group.name;
					}

				}
				return this.$t('translations.unassigned');

			},
            authHeaders () {
                return {
                    'Authorization': axios.defaults.headers.common['Authorization'],
                    'X-Api-Version': axios.defaults.headers.common['X-Api-Version']
                }
            },
            requestTags() {
                return this.$root.lookup.tags.filter(obj => {
                    return obj.tags_tag_use.find(obj2 => {
                        return obj2.tag_use.name == 'request'
                    })
                });
            }
		},
		watch: {
			route: function (val) {
				 this.mounted();
				 //console.log("ROUTE CHANGE!!!!")
			},
			connected (newState, oldState) {
				if(newState == true && this.thread_id) {
					this.checkForUpdates();
				}
			},
			"items.data": {
                handler () {
                    this.loadThumbnails();
                },
                deep: true
            },
            "items.data.length": function() {
                Vue.nextTick(() => {
                    this.scrollToEnd()
                });
                
            },
            internal_message: function() {
                this.saveDraft();
            }
		},

		beforeDestroy() {
			this.deinitData();
		},
		beforeRouteLeave (to, from, next) {
			this.deinitData();
			next();
		},
		mounted() {
			this.last_item_created_at = null;
			this.errors = [];
			this.initData();
			this.thread = null;
			this.thread_id = null;
			
			if(this.type == "edit") {
				this.thread_id = this.$route.params.id;
				
				this.getThread().then(res => {
                    this.initEncryptStorageLocal(this.thread.user_id, this.thread_id);
                    this.loadDraftFromLocalStorage();
                    this.internal_message = this.defaultInternal;
                })
			}
			else if(this.$route.path == "/thread-list/thread-create") {
				this.$router.push({path: "/thread-list/thread-create/0"});
			}
			else if(this.type == "create") {

				if(this.$route.params.user_id) {
					this.user_id = this.$route.params.user_id;
					axios.get('/api/v1/patients/' + this.user_id).then((res) => {
						this.thread = {
                            user: res.data.user,
                            thread_provider: {
                                priority: 0,
                            }
                        };
                        //this.internal_message = !this.emailable;
                        this.initEncryptStorageLocal(this.user_id, 0);
                        // this.startQa().then(() => {
                        //     this.internal_message = !this.emailable;
                        // })
                        this.skipQa();
					}).catch((error) => {
						this.setLoading(false);
						this.handleError(error, "create");
					});
				}
				this.current_question = null;
				//this.items = [];
			}
			//this.showNickelled();
		},
		updated() {
            // if(this.scrollOnUpdate) {
			//     this.scrollToEnd();
            // }
            // this.scrollOnUpdate = true;
        },
        beforeRouteUpdate (to, from, next) {
            this.checkRouteChange(to, from, next);
        },
        beforeRouteLeave(to, from, next) {
            this.checkRouteChange(to, from, next);
        },
		methods: {
            updateThread(e) {
                if(e.thread.id == this.thread_id) {
                    //this.addNotification({type: "success", content: 'New message'});
                    //console.info(e.thread);
                    for (var attrname in e.thread) {
                        //console.log("Setting " + attrname + " to " + e.thread[attrname]);
                        //Vue.set(this.thread, attrname, e.thread[attrname]);
                        this.thread[attrname] = this.copyNonReactive(e.thread[attrname]);
                    }

                    // Because this is a registered handler, it could fire during deinit of the component,
                    // so we have to check that any refs are still initialised.
                    if(this.$refs.threadCodeEdit) {
                        this.$refs.threadCodeEdit.updateList();
                    }
                    
                    // Make sure we have the correct thread_provider object (as it won't necessarily be the current
                    // users one if the thread is multi-provider).
                    if(this.thread.thread_provider_xref) {
                        this.thread.thread_provider = this.thread.thread_provider_xref.find(obj => {return obj.provider_id == this.$root.user.provider.id});
                        if(!this.thread.thread_provider) {
                            this.originalData = null;
                            //this.$parent.getResults();
                            this.closePanel();
                        }
                    }
                    
                    if(this.thread.thread_provider) {
                        this.waiting_until = this.thread.thread_provider.waiting_until;    
                    }
                    
                    if(this.thread.deleted_at) {
                        this.originalData = null;
                        //this.$parent.getResults();
                        this.closePanel();
                    }
                }
            },
            connectChannels() {
                this.registerGlobalListener("UpdateThread", this.updateThread);
                if(this.thread && !this.thread.archived) {
                    window.Echo.private('message.' + this.thread_id)
                        .listen('UpdateThreadAppointment', (e) => {
                            //console.info(e.appointment);
                            for(var index in this.items.data) {
                                if(this.items.data[index].appointment_id == e.appointment.id) {
                                    //console.info("FOUND");
                                    this.items.data[index].appointment = e.appointment;
                                }
                            }
                        });
                        // this.listenWithChunking('message.' + this.thread_id, 'UpdateMessageThread', (e) => {
                        //     //this.addNotification({type: "success", content: 'New message'});
                        //     console.info(e.thread);
                        //     for (var attrname in e.thread) {
                        //         //console.log("Setting " + attrname + " to " + e.thread[attrname]);
                        //         this.thread[attrname] = e.thread[attrname];
                        //     }
                        //     // Make sure we have the correct thread_provider object (as it won't necessarily be the current
                        //     // users one if the thread is multi-provider).
                        //     if(this.thread.thread_provider_xref) {
                        //         this.thread.thread_provider = this.thread.thread_provider_xref.find(obj => {return obj.provider_id == this.$root.user.provider.id});
                        //         if(!this.thread.thread_provider) {
                        //             this.originalData = null;
                        //             //this.$parent.getResults();
                        //             this.closePanel();
                        //         }
                        //     }
                        //     this.waiting_until = this.thread.thread_provider.waiting_until;
                        //     if(this.thread.deleted_at) {
                        //         this.originalData = null;
                        //         //this.$parent.getResults();
                        //         this.closePanel();
                        //     }
                        // });
                        this.listenWithChunking('message.' + this.thread_id, 'NewMessage', (e) => {
                            //console.info("!!!!!!!!", "NewMessage", e);
                            if(this.addMessages([e.message])) {
                                this.setReadActivityMonitor();
                            }
                            //this.checkForUpdates();
                        });
                        this.listenWithChunking('message.' + this.thread_id, 'UpdateMessage', (e) => {
                            var found = false;
                            //console.info("!!!!!!!!", "UpdateMessage", e);
                            for (var index in this.items.data) {
                                if(e.message.id == this.items.data[index].id) {
                                    
                                    for (var attrname in e.message) {
                                        //console.log(attrname + ": " + this.items.data[index][attrname] + " - " + e.message[attrname])
                                        this.items.data[index][attrname] = e.message[attrname];
                                    }
                                    found = true;
                                }
                            }
                            if(!found) {
                                this.getResults();
                            }
                        });

                    window.Echo.join('message-presence.' + this.thread_id)
                        .here((data) => {
                            //console.log("here: " + JSON.stringify(data, null, 2));
                            this.in_thread = this.in_thread.concat(data);
                        })
                        .joining((data) => {
                            //console.log("joining: " + JSON.stringify(data, null, 2));
                            this.in_thread.push(data);
                        })
                        .leaving((data) => {
                            //console.log("leaving: " + JSON.stringify(data, null, 2));
                            this.in_thread = this.in_thread.filter((obj) => {
                                return obj.id !== data.id;
                            });
                        });
                }
            },
            openEdit(event) {
                this.$router.push({path: this.$route.fullPath + "/patient-inline-edit/" + this.thread.user.id});
                // var params = {"id": this.thread.user.id, "returnPath": this.$route.fullPath};
                // if(this.$route.path.indexOf("thread-list") != -1) {
				//     this.$router.push({name: "threadPatientInline", params: params});
                // }
                // else {
                //     this.$router.push({name: "filingPatientInline", params: params});
                // }
                //this.$router.push({name: "filingPatientInline", params: {"id": this.thread.user.id, "thread_id": this.thread_id}});
                //this.$router.push({params: {"thread_id": this.thread_id}, path: "/thread-list/patient-inline-edit/" + this.thread.user.id });
			},
			cancelEditMessage() {
                this.scrollOnUpdate = false;
				this.items.data[this.edit_index].message = this.pre_edit_content;
				this.edit_index = -1;
			},
			editMessage(index) {
                this.scrollOnUpdate = false;
				this.edit_index = index;
				this.pre_edit_content = this.items.data[index].message;
			},
			saveMessage(index) {
                this.scrollOnUpdate = false;
				axios.put(this.apiRoute + '/messages/' + this.items.data[index].id, this.items.data[index]).then((res) => {
					this.edit_index = -1;
					this.setLoading(false);
					this.addNotification({type: "success", content: 'Message updated'});
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "update message");
				});
			},
			// Not used now that we really delete messages (rather than replace the text).
			isMessageDeleted(item) {
				// This is a quick hack really. The messages aren't ever actually deleted just the content replaced.
				return item.message == "[THIS MESSAGE HAS BEEN DELETED]";
			},
			deleteMessage(index) {
				this.$modal.show('dialog', {
					title: this.$t('translations.delete_message'),
					text: this.$t('translations.message_will_be_deleted_continue'),
					buttons: [
					{
						title: this.$t('translations.yes'),
						handler: () => {
							this.$modal.hide('dialog');
							axios.delete(this.apiRoute + '/messages/' + this.items.data[index].id, {}).then((res) => {
								this.items.data.splice(index, 1);
								//this.items.data[index].message = '[THIS MESSAGE HAS BEEN DELETED]';
								this.edit_index = -1;
								this.setLoading(false);
								this.addNotification({type: "success", content: this.$t('translations.message_content_deleted')});
							}).catch((error) => {
								this.setLoading(false);
								this.handleError(error, this.$t('translations.delete_message'));
							});
						},
					},
					{
						title: this.$t('translations.cancel'),
						default: true
					}]});

			},
			deinitData() {
				if(this.read_timer != null) {
					clearTimeout(this.read_timer);
				}
				this.clearReadActivityMonitor();
				this.userId = null;

				window.Echo.leave('message.' + this.thread_id);
				window.Echo.leave('message-presence.' + this.thread_id);

                this.removeGlobalListener("UpdateThread", this.updateThread);
			},

			setVerificationStatus() {
				this.setLoading(true);

				axios.put(this.apiRoute + '/patients/setVerificationStatus/' + this.thread.user.id, {"verification_status_id": this.thread.user.verification_status_id}).then((res) => {
					this.setLoading(false);
					this.addNotification({type: "success", content: 'Successfully set verification status'});
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "set verification status");
				});
			},
			closeThreadSendAssign() {
				this.processMessage().then(() => {
					this.closeThread()
				});
            },
            closeThreadSendAssignPostQa(completed) {
                if((this.attached_images.length || this.attached_documents.length) && !this.new_message.length) {
                    this.$modal.show('dialog', {
                            title: this.$t('translations.unable_to_send_message'),
                            text: this.$t('translations.incomplete_message_unsent_completion'),
                            buttons: [{
                                title: this.$t("translations.close"),
                                handler: () => {
                                    this.$modal.hide('dialog');
                                },
                            }]
                        });
                    return;
                }
				if ( this.thread.user.verification_status_id != 3 && this.thread.user.provider.id == this.$root.user.provider.id) {
				    this.$modal.show('dialog', {
				        title: this.autobrand('translations.verify_client_id'),
				        // text: 'Verify patient ID?',
				        buttons: [
				        {
				            title: 'Yes',
				            handler: () => {
								// Change verification status to 3 if 'yes'
								this.thread.user.verification_status_id = 3;

								axios.put(this.apiRoute + '/patients/setVerificationStatus/' + this.thread.user.id, {"verification_status_id": this.thread.user.verification_status_id}).then((res) => {
									this.setLoading(false);
									this.addNotification({type: "success", content: 'Successfully set verification status'});
								}).catch((error) => {
									this.setLoading(false);
									this.handleError(error, "set verification status");
								});
				                this.$modal.hide('dialog');

								// Continue to close request once option is chosen
								this.processMessage().then(() => {
									this.closeThread(false, completed);
								});
				            },
				        },
				        {
				            title: 'No',
							handler: () => {
								this.$modal.hide('dialog');

								// Continue to close request once option is chosen
								this.processMessage().then(() => {
									this.closeThread(false, completed);
								});
							},
				        },
				    ]
				    });
				}
				else {
					this.processMessage().then(() => {
						this.closeThread(false, completed);
					});
				}
			},
			closeThread(loading, postQaFirstAnswer) {
				this.setLoading(true);
				var post_qa = 1;
				if(this.$root.provider.demo_mode) {
                    this.setRead(true);
                    this.$emit("viewNext", this.thread.id);
					//this.$parent.viewNext(this.thread.id);
					post_qa = 0;
				}

				axios.put(this.apiRoute + '/threads/close/' + this.thread.id + '/' + post_qa, {}).then((res) => {
					this.setLoading(false);

					this.new_message = "";
                    this.preset_message_id = null;
					this.internal_message = this.defaultInternal;
                    this.thread.closed_at = res.data.closed_at;
                    // We can set the assignment when closing threads that aren't assigned to anyone.
                    this.thread.thread_provider.assigned_user_id = res.data.thread_provider.assigned_user_id;
                    this.thread.thread_provider.assigned_group_id = res.data.thread_provider.assigned_group_id;
                    this.thread.thread_provider.assigned_user = res.data.thread_provider.assigned_user;
                    this.thread.thread_provider.assigned_group = res.data.thread_provider.assigned_group;

                    // The question_group_id can also change for the post-qa
					this.thread.question_group_id = res.data.question_group_id;
					if(this.thread.question_group_id) {
						this.startPostQa(postQaFirstAnswer);
					}
					this.addNotification({type: "success", content: 'Thread closed'});
					if(!this.$root.provider.demo_mode) {
						//console.log("DEBUG2: " + this.items.data.length);
						//console.log("DEBUG2: " + this.items.data[this.items.data.length - 1].message);
                        this.allowOtherWriteback = true;
						this.$refs.copyDialog.show();
					}
					else {
						// this.setRead(true);
						// this.$parent.viewNext(this.thread.id);
					}
				}).catch((error) => {
					if(loading === true) {
						this.setLoading(false);
					}
					this.handleError(error, "close");
				});
			},
            updateCompletion(postQaFirstAnswer) {
                this.setLoading(true);
                //this.closeThreadSendAssignPostQa(completed);
                
                axios.put(this.apiRoute + '/threads/triggerPostQa/' + this.thread.id, {}).then((res) => {
                    this.setLoading(false);
                    this.getResults().then(() => {
                        this.thread.question_group_id = res.data.question_group_id;
                        if(this.thread.question_group_id) {
                            this.startPostQa(postQaFirstAnswer);
                        }
                        this.suppress_close_panel = true;
                    });                    
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "update completion");
                });
            },
			reopenThread() {
				this.setLoading(true);

				axios.put(this.apiRoute + '/threads/reopen/' + this.thread.id, {}).then((res) => {
					this.setLoading(false);
					this.new_message = "";
                    this.preset_message_id = null;
					this.internal_message = this.defaultInternal;
                    this.thread.closed_at = null;
                    this.current_question = null;
                    this.thread.question_group_id = null;
                    this.thread.question_group = null;
                    this.show_text_input = true;
                    this.question_buttons = [];
                    this.question_render = "";

                    this.addNotification({type: "success", content: this.$t('translations.thread_reopened')});
                    
                    this.$emit("reopen");
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "reopen");
				});
            },
            deleteThread() {
                this.$modal.show('dialog', {
					title: this.autobrand('translations.delete_request'),
					text: this.autobrand('translations.you_are_about_to_delete_request') + this.thread.id + " " + this.$t('translations.for') + " " + this.formatNameCompliant(this.thread.user) + ". " + this.$t('translations.are_you_sure_you_want_to_continue'),
					buttons: [
					{
						title: this.$t('translations.yes'),
						handler: () => {
							this.$modal.hide('dialog');
                            this.setLoading(true);
                            axios.delete(this.apiRoute + '/threads/' + this.thread.id).then((res) => {
                                this.setLoading(false);
                                this.addNotification({type: "success", content: this.$t('translations.thread') + " " + this.thread.id + " " + this.$t('translations.deleted')});
                                this.$emit("delete")
                                this.originalData = null;
                                this.closePanel();
                            }).catch((error) => {
                                this.setLoading(false);
                                this.handleError(error, "delete");
                            });
						},
					},
					{
						title: this.$t('translations.cancel'),
						default: true
					}]});
			},
			getAbsoluteHeight(el) {
			  // Get the DOM Node if you pass in a string
			  el = (typeof el === 'string') ? document.querySelector(el) : el;

			  var styles = window.getComputedStyle(el);
			  var margin = parseFloat(styles['marginTop']) +
						   parseFloat(styles['marginBottom']);

			  return 0.0 + el.offsetHeight + margin;
			},
			closePanel(bubble, change) {
				this.$router.push({path: "/thread-list"});
			},
			getQuestions(type) {
				return axios.get(this.apiRoute + '/questions/' + type, {message: this.new_message, thread_id: this.thread_id}).then((res) => {
					//this.setLoading(false);
					this.questions = res.data;
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "create");
				});
			},
			getQuestionsById(id) {
				return axios.get(this.apiRoute + '/questions/getById/' + id, {message: this.new_message, thread_id: this.thread_id}).then((res) => {
					//this.setLoading(false);
					this.questions = res.data;
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "create");
				});
			},
            skipQa() {
                this.new_message = "";
                this.preset_message_id = null;
                this.internal_message = this.defaultInternal;
                this.thread.closed_at = null;
                this.current_question = null;
                this.thread.question_group_id = null;
                this.thread.question_group = null;
                this.show_text_input = true;
                this.question_buttons = [];
                this.question_render = "";
                this.cache = [];
                this.items.data = [];
                this.have_question_answers = false;
			},
			startPostQa(firstAnswer) {
				this.getQuestions("provider_outcome").then(() => {
					this.current_question = Object.keys(this.questions)[0];
					this.new_message = "";
                    this.preset_message_id = null;
                    this.internal_message = 0;
                    if(firstAnswer) {
                        this.new_message = firstAnswer;
						this.processMessage();
                    }
                    this.renderQuestion();
				});
			},
			lastQuestion() {
				if(this.current_question) {
					for(var index in this.questions[this.current_question].branch_rule) {
						//console.log("Testing branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
						if(this.questions[this.current_question].branch_rule[index].rule == this.new_message ||
								this.questions[this.current_question].branch_rule[index].rule == null) {
							return false;
						}
					}

					return true;
				}
				return false;
			},
			getSendButtonText() {
				if(this.lastQuestion()) {
					return this.$t('translations.finish');
				}
				if(this.current_question) {
					return this.$t('translations.next');
				}
				return this.$t('translations.send');
            },
            updateParentThreadListing() {

                /**
                 * @todo This needs changing to an emit. Currently we have to loop through both the root request listing
                 * and the parent request listing as the request might be in either one, or even both if it's an advanced
                 * search. The parent ThreadList 
                 */
                for(var index in this.$root.requests) {
                    if(this.$root.requests[index].id === this.thread.id) {
                        if(typeof this.$root.requests[index].user_thread_read_status !== 'object' || this.$root.requests[index].user_thread_read_status === null) {
                            Vue.set(this.$root.requests[index], "user_thread_read_status", {read_at: null});
                        }
                        this.$root.requests[index].user_thread_read_status.read_at = this.items.data[this.items.data.length - 1].created_at;
                        //this.$root.requests[index].latest_message = this.items.data[this.items.data.length - 1];
                    }
                }
                for(var index in this.$parent.items.data) {
                    if(this.$parent.items.data[index].id === this.thread.id) {
                        if(typeof this.$parent.items.data[index].user_thread_read_status !== 'object' || this.$parent.items.data[index].user_thread_read_status === null) {
                            Vue.set(this.$parent.items.data[index], "user_thread_read_status", {read_at: null});
                        }
                        this.$parent.items.data[index].user_thread_read_status.read_at = this.items.data[this.items.data.length - 1].created_at;
                        //this.$parent.items.data[index].latest_message = this.items.data[this.items.data.length - 1];
                    }
                }
            },
            inviteSent(invite) {
                this.getResults();
            },
			sendMessage(thread_data = false) {
				this.setLoading(true);
				var data = {
					message: this.new_message,
                    preset_message_id: this.preset_message_id,
					thread_id: this.thread_id,
					internal: this.internal_message,
                    auxiliary_data: this.auxiliary_data,
                    attached_images: this.attached_images,
                    attached_documents: this.attached_documents,
                    attached_form: this.attached_form
				};
				var next_question = null;
				var auto_complete = false;
				var close_panel = false;

				this.errors = [];

				if(this.current_question != null) {
					data.question_id = this.questions[this.current_question].id;

					for(var index in this.questions[this.current_question].branch_rule) {
						//console.log("Testing branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
						if(this.questions[this.current_question].branch_rule[index].rule == this.new_message ||
								this.questions[this.current_question].branch_rule[index].rule == null) {
							next_question = "q-" + this.questions[this.current_question].branch_rule[index].to_question_id;
						}
					}

                    // Bit of a hack, and we need to re-write QA permissions based on branching at some point,
                    // but for now, if the question is marked as being for members of groups with the
                    // completes_on_behalf_of permission, and this user isn't in any of those groups,
                    // we finish the QA.
                    // alert(next_question);
                    // alert(this.questions[next_question].group_completes_on_behalf_of);
                    // alert(this.completesOnBehalfOf());
                    if(next_question != null && this.questions[next_question].group_completes_on_behalf_of && !this.completesOnBehalfOf()) {
                        next_question = null;
                    }

					if(next_question == null) {
						data.end_qa = true;
						if(this.$root.provider.demo_mode) {
							auto_complete = true;
						}
					}
				}
				//console.log("Next question: " + next_question);
				//console.log("Sending message: " + JSON.stringify(data, null, 2));

                //return axios.post(this.apiRoute + '/messages'
				return this.postMessage(this.apiRoute + '/messages'
						, data
						, {headers: {'Content-Type': 'multipart/form-data' }}
                        , thread_data).then((res) => {
					//this.setAssignee();
					this.setLoading(false);

					this.new_message = "";
                    this.preset_message_id = null;
					this.auxiliary_data = "";
					this.internal_message = this.defaultInternal;
                    this.attached_images = [];
                    this.attached_documents = [];
                    this.attached_form = null;

					if(this.current_question) {
						if(next_question != null) {
							this.current_question = next_question;
                            this.internal_message = 0;

                            this.renderQuestion();

                            this.retrieveSavedItem();
						}
						else {
							this.current_question = null;
							this.thread.question_group_id = null;
							this.thread.question_group = null;
							this.show_text_input = true;
							this.question_buttons = [];
							this.question_render = "";
                            if(!this.suppress_close_panel && !this.$refs.copyDialog.shown) {
                                close_panel = true;
                            }
							//this.$parent.getResults();
						}
					}
					
                    var set_activity_monitor = false;

					// If the message creation returns a message, add it to the items.
					if(typeof this.items.data !== 'undefined' && res.data.message) {
                        //console.log("Incoming message from sendMessage")
                        if(this.addMessages([res.data.message])) {
                            // Removed for now. Logically in send_message we should only ever get our
                            // own messages returned. So the setRead only needs to happen on first load,
                            // and in the websocket listener for new messages.
                            //set_activity_monitor = true;
                        }

                        //this.last_item_created_at = res.data.message.created_at;
                        //this.items.data.push(res.data.message);
						if(res.data.message.question_id != null && res.data.message.question.question_group.question_group_type_id == 1) {
							this.have_question_answers = true;
						}
                        //console.warn("res.data.thread", res.data.thread);
                        if(res.data.thread && res.data.thread.id) {
                            this.$root.addOrUpdateItem(res.data, []);
                        }
						//this.checkForUpdates();
					}
					else {
						this.getResults();
					}

					if(res.data.thread) {
						for (var attrname in res.data.thread) {
						 	//console.log("Setting " + this.thread[attrname] + " to " + res.data.thread[attrname]);
							this.thread[attrname] = res.data.thread[attrname];
						}
					}

                    // Do this after all the other thread updates have been processed,
                    // but before the auto_complete (if one is going to fire)
                    if(set_activity_monitor) {
                        this.setReadActivityMonitor();
                    }

					if(auto_complete) {
						this.closeThread();
					}
					else if(close_panel) {
                        this.originalData = null;
                        // Pass the close_panel out to the caller to prevent any channel init
                        res.close_panel = true;
						//this.$parent.requestGetResults();
						this.closePanel();

                    }
                    this.updateParentThreadListing();
                    return Promise.resolve(res);

				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "create");
				});
			},
			processSendAssign() {
				this.processMessage();
			},
			showFollowUp() {
                var time = this.moment(this.$root.provider.wait_exit_time, "HH:mm");
                this.follow_up_at = this.moment().add(7, "days")
                    .set({hour: time.get('hour'), minute: time.get('minute'), second: 0})
                    .format("YYYY-MM-DD HH:mm");
                this.follow_up_wait_until = this.moment(this.follow_up_at).add(this.$root.provider.wait_default_days, "days")
                    .set({hour: time.get('hour'), minute: time.get('minute'), second: 0})
                    .format("YYYY-MM-DD HH:mm");
                this.post_follow_up_complete = 0 //(this.thread.thread_provider_xref && this.thread.thread_provider_xref.length == 1) ? 1 : 0;
				this.follow_up_message = "";
				this.$refs.setFollowUpModal.show();
            },
            setFollowUp(event) {
				var date = null;
                this.errors = [];
				
                var follow_up_date = this.moment(this.follow_up_at).format("YYYY-MM-DD HH:mm");;
                var follow_up_wait_until = this.moment(this.follow_up_wait_until).format("YYYY-MM-DD HH:mm");;
				
				this.$root.setLoading(true);
				var data = {
					"follow_up_at": follow_up_date,
					"follow_up_wait_until": follow_up_wait_until,
					"post_follow_up_complete": this.post_follow_up_complete,
					"follow_up_message": this.follow_up_message
				}
				this.errors = [];
				axios.put(this.apiRoute + '/threads/setFollowUp/' + this.thread.id, data).then((res) => {
					this.$refs.setFollowUpModal.hide();

					this.thread.follow_up_at = follow_up_date;
					this.thread.follow_up_wait_until = follow_up_wait_until;
					this.thread.post_follow_up_complete = this.post_follow_up_complete;
					this.thread.follow_up_message = this.follow_up_message;
					this.$root.setLoading(false);
					this.addNotification({type: "success", content: 'Set follow up'});
					return true;
				}).catch((error) => {
					this.$root.setLoading(false);
					this.handleError(error, "set follow up");
					//this.$refs.setFollowUpModal.show();
				});
				event.preventDefault();
				return false;
			},
			cancelFollowUp() {
				this.setLoading(true);
				this.follow_up_at = null;
				this.follow_up_wait_until = null;
				this.post_follow_up_complete = null;
				this.follow_up_message = "";
				axios.put(this.apiRoute + '/threads/setFollowUp/' + this.thread.id, {"follow_up_at": null}).then((res) => {
					this.thread.follow_up_at = this.follow_up_at;
					this.thread.follow_up_wait_until = this.follow_up_wait_until;
					this.thread.post_follow_up_complete = this.post_follow_up_complete;
					this.thread.follow_up_message = this.follow_up_message;
					this.setLoading(false);
					this.addNotification({type: "success", content: 'Follow up cancelled'});
					return true;
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "cancel follow up");
				});
			},
			showWait() {
				this.$refs.setWait.show();
            },
            setWait() {
                this.setLoading(true);
                this.processMessage().then(message => {
                    this.$refs.setWait.set().then(message => {
                        this.allowOtherWriteback = false;
                        this.$refs.copyDialog.show()
                    });
                })
                .catch(error => {
                    this.setLoading(false);
					this.handleError(error, "cancel follow up");
                });
            },
            resetModalErrors() {
                this.errors=[];
            },

			endWait() {
				this.setLoading(true);
				this.waiting_until = null;
				axios.put(this.apiRoute + '/threads/setWait/' + this.thread.id, {"waiting_until": null}).then((res) => {
					this.thread.thread_provider.waiting_until = null;
					this.setLoading(false);
					this.addNotification({type: "success", content: this.$t('translations.wait_ended')});
					return true;
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "end wait");
				});
			},
			processMessage() {
                if((this.attached_images.length || this.attached_documents.length) && !this.new_message.length) {
                    this.$modal.show('dialog', {
                            title: this.$t('translations.unable_to_send_message'),
                            text: this.$t('translations.incomplete_message_unsent'),
                            buttons: [{
                                title: this.$t("translations.close"),
                                handler: () => {
                                    this.$modal.hide('dialog');
                                },
                            }]
                        });
                    return;
                }
				if(this.new_message) {
                    var thread_data = null
                    if(this.thread_id == null && !this.hasNextQuestion()) {
                        var thread_data = {user_id: this.user_id, subject: this.new_message};

                        // Only contains the initial priority (moved from thread.priority to thread_provider_xref)
                        if(this.thread && this.thread.thread_provider && this.thread.thread_provider.priority) {
                            thread_data.thread_provider_priority = this.thread.thread_provider.priority;
                        }

                        /**
                         * Temporary fix whilst we wait for something better.
                         * Remove the message from the subject line if the first message is internal.
                         */
                        if(this.internal_message) {
                            thread_data.subject = "[No Subject]";
                        }

                        if(this.current_question && this.questions[this.current_question]) {
                            thread_data["question_group_id"] = this.questions[this.current_question].question_group_id;
                        }
                        if(this.cache.length) {
                            thread_data["suppress_broadcast"] = true;
                        }
                    }

					if(!this.internal_message && !this.current_question && this.confirm_patient_messages) {
						this.$modal.show('dialog', {
							title: this.$t('translations.send_message'),
							text: this.autobrand('translations.request_will_go_to_patient_confirmation'),
							buttons: [
							{
								title: this.$t('translations.okay'),
								handler: () => {
									this.$modal.hide('dialog');
									
									return this.sendMessage(thread_data).then(res => {
                                        if(thread_data && !res.close_panel) {
                                            this.thread_id = res.data.thread.id;
                                            this.thread = res.data.thread;

                                            this.connectChannels();
                                            // We don't need this because the provider doesn't generate
                                            // automatic messages on QA completion (compare the patient MessageList).
                                            // However, I'm leaving it here in case we add any auto messages in the
                                            // future.
                                            //this.checkForUpdates();
                                        }
                                    });
								},
								default: true
							},
							{
								title: this.$t('translations.cancel'),
								handler: () => {
									return Promise.reject();
								}
							}]});

					}
					else {
						return this.sendMessage(thread_data).then(res => {
                            if(thread_data && !res.close_panel) {
                                this.thread_id = res.data.thread.id;
                                this.thread = res.data.thread;

                                this.connectChannels();
                                // We don't need this because the provider doesn't generate
                                // automatic messages on QA completion (compare the patient MessageList).
                                // However, I'm leaving it here in case we add any auto messages in the
                                // future.
                                //this.checkForUpdates();
                            }
                        });
					}
				}
				// else {
				// 	return this.setAssignee();
				// }
				return Promise.resolve();
			},
			renderQuestion() {
					//console.log("current_question: " + this.current_question);
					//console.log("question: " + JSON.stringify(this.questions[this.current_question], null, 2));

					switch(this.questions[this.current_question].question_type_id) {
						case 1:
							this.show_text_input = true;
							this.question_render = this.autobrand('qa.' + this.questions[this.current_question].content);
							this.question_buttons = [];
							break;
						case 2:
							this.show_text_input = false;
							this.question_render = this.autobrand('qa.' + this.questions[this.current_question].content);
							this.question_buttons = [];
							for(var index = 0; index < this.questions[this.current_question].question_option.length; index++) {
                                var display = true;
                                if(this.questions[this.current_question].question_option[index].name == 'option_female_clinician'
                                        || this.questions[this.current_question].question_option[index].name == 'option_male_clinician') {
                                    if(!this.$root.provider.clinician_gender_selection_enabled) {
                                        display = false;
                                    }
                                }
                                if(display) {
                                    this.question_buttons.push({
                                        text: this.autobrand('qa.' + this.questions[this.current_question].question_option[index].name),
                                        value: this.autobrand('qa.' + this.questions[this.current_question].question_option[index].value),
                                        action: "next",
                                    });
                                }
							}
							break;
						case 3:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [{
								text: this.$t('qa.option_view_online_resources'),
								action: "launch_search",
								value: this.$t('qa.option_val_view_online_resources'),
							},
							{
								text: this.$t('qa.option_continue_to_askmyGP'),
								action: "next",
								value: this.$t('qa.option_val_continue_to_askmyGP'),
							}];

							break;
						case 4:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+ this.questions[this.current_question].content);
							this.question_buttons = [];
							this.question_buttons.push({
								text: this.$t('qa.option_anyone'),
								action: "next",
								value: this.$t('qa.option_val_anyone'),
							});
							for(var index = 0; index < this.staff.length; index++) {
								if(this.isMemberOfAssignableGroup(this.staff[index])) {
									this.question_buttons.push({
										text: this.formatName(this.staff[index]),
										action: "next",
										value: this.formatName(this.staff[index]),
										auxiliary_data: this.staff[index].id,
									});
								}
							}

                            break;
                        case 5:
							this.show_text_input = false;
							this.question_render = this.$t('qa.'+this.questions[this.current_question].content);
							this.question_buttons = [];
							// this.question_buttons.push({
							// 	text: "Anyone",
							// 	action: "next",
							// 	value: "Anyone",
							// });
							for(var index = 0; index < this.staff.length; index++) {
								//if(this.isMemberOfAssignableGroup(this.staff[index])) {
									this.question_buttons.push({
										text: this.formatName(this.staff[index]),
										action: "next",
										value: this.formatName(this.staff[index]),
										auxiliary_data: this.staff[index].id,
									});
								//}
							}

							break;
					}
			},
			questionClick(index) {
				//console.log("questionClick(): " + index);
				//this.questions[this.current_question].question_type_id
				switch(this.questions[this.current_question].question_type_id) {
					case 2:
					case 4:
                    case 5:
						this.new_message = this.question_buttons[index].value;
						if(this.question_buttons[index].auxiliary_data) {
							this.auxiliary_data = this.question_buttons[index].auxiliary_data;
						}
						this.processMessage();
						break;
					case 3:
						switch(this.question_buttons[index].action) {
							case "launch_search":
								break;
							case "next":
								this.new_message = this.question_buttons[index].value;
								this.processMessage();
								break;
						}
						break;
				}
			},

			getMessageClass(id) {
				if(this.$root.user) {
					if(this.$root.user.id == id) {
						return "message-mine";
					}
					else {
						return "message-other";
					}
				}
			},
			getMessageAuto(index) {
				if(this.$data.items.data[index].automated) {
					return "message-automated";
				} else {
					return "";
				}
			},
			// @updatehere
			initData() {
				// Not loading any relatedData stuff here any more. Use root lookups instead.
				this.initFilters();

			},
			// @updatehere
			initFilters() {

			},
			initStats(showLoading) {
                this.stats.user_assignment_today = this.$root.lookup.user_assignment_today;
	            // if(showLoading === true) {
	            //     this.setLoading(true);
	            // }

	            // axios.get('/api/v1/threads/getUserAssignedToday', {params: {site_id: this.site_id}}).then((res) => {
	            //     this.setLoading(false);
	            //     this.stats = res.data;
	            // }).catch((error) => {
	            //     this.setLoading(false);
	            //     this.handleError(error, "create");
	            // });
			},
			// @updatehere
			getThread() {
				this.setLoading(true);

				return axios.get(this.apiRoute + '/threads/' + this.thread_id + (this.$route.params.archive ? "/1" : "")).then((res) => {
					//console.log(res.data);

					this.thread = res.data["thread"];

					this.internal_message = this.defaultInternal;
                    this.connectChannels();

					this.getResults();
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "load");
					this.$router.push({path: "/thread-list"});
				});
			},
			addMessages(messages) {
                var added = 0;
				for(var new_index in messages) {
                    let found = false;
					let new_id = messages[new_index].id;
					//console.log("addMessages: NEW MESSAGE RECEIVED: " + new_id);
					for(var cur_index in this.items.data) {
						if(this.items.data[cur_index].id == new_id) {
							found = true;
							//console.log("addMessages: AVOIDED COLLISION: " + this.items.data[cur_index].id + ":" + new_id);
						}
					}
					if(!found) {
						//console.log("addMessages: ADDING MESSAGE: " + new_id);
						this.items.data.push(messages[new_index]);
                        added++;
					}
				}
				this.last_item_created_at = this.items.data[this.items.data.length - 1].created_at;

                return added;
			},
			setReadActivityMonitor() {
                //console.info("setReadActivityMonitor");
				this.clearReadActivityMonitor();
				var moveEvents = ["mousemove", "mousedown", "keypress", "wheel", "touchstart"];
				this.monitoringReadActivity = true;
				for(var index in moveEvents) {
					this.events.push({type: moveEvents[index], listener: this.setRead});
					window.addEventListener(moveEvents[index], this.setRead);
					//window.addEventListener(moveEvents[index], this.setRead, {once: true});
				}
			},
			clearReadActivityMonitor() {
				this.monitoringReadActivity = false;
				while(this.events.length) {
					var event = this.events.pop();
					//console.log("removing: " + event.type + " - " + event.listener);
					window.removeEventListener(event.type, event.listener);
				}
			},
			setReadTimer() {
				if(this.read_timer != null) {
					clearTimeout(this.read_timer);
				}
				this.read_timer = setTimeout(this.setRead, 3000);
			},
			setRead(force) {
                if(force || this.monitoringReadActivity) {
					if(this.thread && !this.thread.archived && this.thread.id) {
						this.clearReadActivityMonitor();
						if(this.items.data && this.items.data.length) {
                            var readAt = this.moment().format('YYYY-MM-DD HH:mm:ss.SSS');
                            if(this.items.data.length && this.items.data[this.items.data.length - 1].created_at) {
                                readAt = this.items.data[this.items.data.length - 1].created_at;
                            }
                            axios.put(this.apiRoute + '/threads/setRead/' + this.thread.id + '/' + encodeURI(readAt), {}).then((res) => {
                                this.updateParentThreadListing();
                            }).catch((error) => {
                                this.setLoading(false);
                                this.handleError(error, "create");
                            });
						}
					}
                    else {
                        console.warn("No thread ID set. Not setting read!");
                    }
				}
			},
			getResults(page, event, prevent) {
                if(this.thread_id) {
                    this.setLoading(true);

                    if (typeof page !== 'undefined') {
                        this.page = page;
                    }

                    return axios.get(this.apiRoute + '/messages/thread/' + this.thread_id + '?page=' + this.page  + (this.$route.params.archive ? "&archive=1" : "")).then((res) => {
                        //console.log("current_page: " + res.data.current_page);
                        //console.log("last_page: " + res.data.last_page);
                        if(res.data.current_page > res.data.last_page && prevent !== true) {
                            //console.log("Re-searching with page in range.");
                            this.items = {};
                            this.getResults(res.data.last_page, undefined, true)
                        }
                        else {
                            this.setLoading(false);
                            if(this.items.data) {
                                this.items.data.length = 0;
                            }
                            else {
                                this.items.data = [];
                            }
                            for(var index in res.data.data) {
                                res.data.data[index]["edit"] = false;
                                this.items.data.push(res.data.data[index]);
                            }
                            //console.log("this.items.data.length: " + this.items.data.length);
                            if(this.items.data.length) {
                                this.last_item_created_at = this.items.data[this.items.data.length - 1].created_at;
                            }
                            this.setReadActivityMonitor();
                            this.have_question_answers = false;
                            for(var item in this.items.data) {
                                //console.log("item: " + item);
                                if(this.items.data[item].question_id != null && this.items.data[item].question.question_group.question_group_type_id == 1) {
                                    this.have_question_answers = true;
                                }
                            }

                            // Re-init any ongoing qa
                            if(this.items.data.length) {
                                var current = this.items.data[this.items.data.length - 1];
                                if(this.thread && this.thread.question_group_id) {
                                    //console.log("Reinitialising QA");
                                    // HERE - this background task causes the message list to resize
                                    // which delays the update. How to fix?
                                    this.getQuestionsById(this.thread.question_group_id).then(() => {
                                        var next_question = null;
                                        if(current.question_id) {
                                            //console.log("Attempting to start from current question: " + current.question_id)
                                            this.current_question = "q-" + current.question_id;
                                            // We could have back to back QAs, so make sure the last question
                                            // was part of this QA, otherwise we are starting a new one.
                                            if(typeof this.questions[this.current_question] == "undefined") {
                                                //console.log("Resetting to first question of QA for back to back");
                                                next_question = "q-" + this.questions[Object.keys(this.questions)[0]].id;
                                            }
                                            else {
                                                for(var index in this.questions[this.current_question].branch_rule) {
                                                    //console.log("xTesting branch: " + JSON.stringify(this.questions[this.current_question].branch_rule[index], null, 2));
                                                    if(this.questions[this.current_question].branch_rule[index].rule == current.message ||
                                                            this.questions[this.current_question].branch_rule[index].rule == null) {
                                                        next_question = "q-" + this.questions[this.current_question].branch_rule[index].to_question_id;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            // New QA with no current answers.
                                            next_question = "q-" + this.questions[Object.keys(this.questions)[0]].id;
                                        }

                                        // Bit of a hack, and we need to re-write QA permissions based on branching at some point,
                                        // but for now, if the question is marked as being for members of groups with the
                                        // completes_on_behalf_of permission, and this user isn't in any of those groups,
                                        // we finish the QA.
                                        if(next_question != null && this.questions[next_question].group_completes_on_behalf_of && !this.completesOnBehalfOf()) {
                                            next_question = null;
                                        }

                                        if(next_question != null) {
                                            this.current_question = next_question;
                                            this.renderQuestion();
                                        }
                                        else {
                                            this.current_question = null;
                                            this.show_text_input = true;
                                            this.question_buttons = [];
                                            this.question_render = "";
                                            //this.$parent.getResults();
                                        }

                                        //console.log("Starting from: " + this.current_question);

                                    });
                                }
                            }

                            //
                            return Promise.resolve();
                        }
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
			},
			checkForUpdates() {
                // var err = new Error();
                // console.warn(err.stack);
                if(this.thread_id) {
                    //console.log("Checking for updates ...");

                    if(!this.last_item_created_at) {
                        //console.log("Oops. checkForUpdates() called without a last_item_created_at set.");
                        return this.getResults();
                    }
                    // var search = encodeURIComponent(JSON.stringify([
                    //  {"field": "thread.id", "value": this.thread_id, "type": "="},
                    //  {"field": "created_at", "value": this.last_item_created_at, "type": ">"}]));
                    var date = encodeURIComponent(this.last_item_created_at);
                    //axios.get('/api/v1/messages?search=' + search + '&page=' + this.page).then((res) => {
                    axios.get(this.apiRoute + '/messages/thread/' + this.thread_id + '/' + date + '?page=' + this.page).then((res) => {
                        if(res.data.data.length) {
                            this.addMessages(res.data.data);
                        }
                        this.setReadActivityMonitor();
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
			},
			openCreate(event) {
				//console.log('load-' + this.event + '-create');
			},
			showRightPanel(event) {
				//console.log(event.data);
				data: {
					showRightPanel: false
				}
			},
			scrollToEnd(event) {
				if(this.$el && this.$el.querySelector) {
					var container = this.$el.querySelector(".message-item");
					if(container) {
						container.scrollTop = container.scrollHeight;
					}
				}
			},

			debug() {
				//console.log(this.items.data)
			},
			
			unlockThread() {
				while(this.in_thread.length && this.in_thread[0].id != this.$root.user.id) {
					this.in_thread.shift();
				}
			},


			showVideo() {
				this.$refs.videoChatModal.show();
			},


			sendVideoRequest() {
				this.$refs.videoChatModal.hide();
				this.setLoading(true);

				var data = {thread_id: this.thread_id,
					room: Gruveo.Embed.generateRandomCode()};

				axios.post(this.apiRoute + '/messages/sendVideoRequest', data).then((res) => {
                    
					if(typeof this.items.data !== 'undefined') {
						this.last_item_created_at = res.data.message.created_at;
						this.items.data.push(res.data.message);

                        if(res.data.sms) {
                            this.addNotification({type: "success", content: this.$t('translations.sms_sent', {"phone": res.data.sms})});
                        }

						this.checkForUpdates();
					}
					else {
						this.getResults();
					}
					this.setLoading(false);
					//this.addNotification({type: "success", content: 'Assigned thread to: ' + this.assignee_name});
					return true;
				}).catch((error) => {
					this.setLoading(false);
					this.handleError(error, "video request");
				});
            },
            
            editAppointment(appointment) {
                this.selected_appointment = appointment;
                Vue.nextTick(() => {
                    this.$refs.editAppointment.show();
                });
            },
            
            attach_form(event) {
                // We don't want to attach the whole form object here, and then send it back to the server.
                // We only need the title (for local display) and the ID.
                this.attached_form = {
                    title: event.title,
                    id: event.id
                };
                if(!this.new_message) {
                    this.new_message = this.autobrand('translations.fill_form_blurb');
                }
            },
            detach_form() {
                this.attached_form = null;
                if(this.new_message == this.autobrand('translations.fill_form_blurb')) {
                    this.new_message = "";
                    this.preset_message_id = null;
                }
            },
            setDisplayValue() {
                this.scrollOnUpdate = false;
                Vue.nextTick(() => {
                    if(this.$refs.ac.value) {
                        var tag = this.$root.lookup.tags.find(obj => {return obj.id == this.$refs.ac.value});
                        if(tag) {
                            //this.$refs.ac.display = tag.name;
                            this.addTag();
                            //this.$refs.ac.clear();

                        }
                    }
                });
            },
            updateTags() {
                if(this.thread_id) {
                    this.setLoading(true);
                    axios.put(this.$root.apiBase + '/threads/updateTags/' + this.thread.id, {thread_tag: this.thread.thread_tag}).then((res) => {
                        this.setLoading(false);
                        //this.addNotification({type: "success", content: 'Assigned thread to: ' + this.assignee_name});
                        return true;
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "tag");
                        return false;
                    });
                }
            },
            addTag() {
                if(!this.thread.thread_tag.find(obj => {return obj.tag_id == this.tag})) {
                    this.thread.thread_tag.push({tag_id: this.tag});
                    this.updateTags();
                }
                this.tag = null;
                this.$refs.ac.clear();
                
            },
            deleteTag(index) {
                this.thread.thread_tag.splice(index, 1); 
                this.updateTags();
            },
            wouldLikeHelpFrom() {
                var clinician = this.items.data.find(obj => {
                    return (obj.question && this.$t("qa." + obj.question.short_content) == this.$t("qa.sc_clinician"))
                });
                if(!clinician) {
                    clinician = this.items.data.find(obj => {
                        return (
                            obj.question 
                            && this.$t("qa." + obj.question.short_content) == this.$t("qa.sc_like_help_from")
                            && obj.message != this.$t("qa.option_val_anyone"))
                            
                    }); 
                }
                return clinician;
            },
		}
	}
</script>
